import { doc, getDoc } from "firebase/firestore";
import { db } from "@/services/config";

export const useHydratedUser = () => {
  const getUser = async (uid: string) => {
    const snap = await getDoc(doc(db, "users", uid));

    if (!snap.exists()) return null;

    return snap.data();
  };

  return { getUser };
};
